import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const approvalFlow = (data, id, type) => {
  return axios.request({
    url: workFlowBaseUrl + type + '/approval/' + id + '/',
    data: data,
    method: 'put'
  })
}
